<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wY96kB/tc-custom/9781429966160.jpg?1718183632972" alt="This image is the cover for the book Dinosaur Princess, The Dinosaur Lords"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dinosaur Princess, The Dinosaur Lords
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Dinosaur Princess</i> is a thrilling epic fantasy adventure set in an alternative world of intrigue, beauty, brutality…and dinosaurs.<br/></b><br/><b>WELCOME TO PARADISE: </b>A primordial world with every species of dinosaur, large and small. And humans, who were brought to this world on the whim of the gods<b>. </b>Knights ride into battle on Triceratops; their heroes lead them on T-Rexes.<br/><br/>Karyl Bogomirskiy is one such hero. Once, he held power. Betrayed by those closest to him, he was resurrected by the Fae, magical beings native to the world, who seek to use him in their eternal battle against alien gods. Karyl just wants to be left in peace, reluctant to be anyone’s tool, much less a savior.<br/><br/>But the gods have returned to judge their human experiment and to finally rid the planet of the Fae. And while Karyl doesn’t feel like a hero, he’s humanity’s last best hope.<br/><br/><i>The Dinosaur Princess</i> is the newest epic fantasy adventure set in a world where knights ride armored dinosaurs into battle, hailed by George R. R. Martin as "A cross between <i>Jurassic Park </i>and <i>Game of Thrones."</i><br/><br/><b>The Dinosaur Lords Series</b><br/>#1 <i>The Dinosaur Lords</i><br/>#2 <i>The Dinosaur Knights</i><br/>#3 <i>The Dinosaur Princess</i><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victor Milán
      </h2>
      
      <p class="authorDescription body article">In previous worlds VICTOR MILÀN has been a cowboy and Albuquerque's most popular all-night prog-rock DJ. He's also the author of the award-winning<I> Cybernetic Samurai</I>, and <I>The Dinosaur Lords.</I> He's never outgrown his childhood love of dinosaurs . . . and hopes you didn't either.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c6be162